import mapValues from 'lodash/mapValues';

import { currencyCode } from 'Helpers/Geo/data';

/**
 *
  * Formats the part of bundle information for a product.
  * It checks if the product is part of a bundle and formats the first pick and mix tier.
  * If the product has a pick and mix tier, it adds it to the bundles array
  * It also converts prices to a fixed format and calculates discounts if applicable.
  * @param {*} bundles - Array of bundles associated with the product.
  * @param {*} firstPickAndMixTier - The first pick and mix tier for the product.
 * @returns
 */
const FormatPartOfBundle = (
  bundles = [],
  firstPickAndMixTier = {},
) => {
  const pickAndMixQuantity = firstPickAndMixTier.quantity || 0;
  const pickAndMixPrice = firstPickAndMixTier.price;
  const pickAndMixPercent = firstPickAndMixTier.percent;
  const bundleIds = bundles.map(bundle => bundle._id);
  const showPickAndMix = pickAndMixQuantity > 0 && !bundleIds.includes(firstPickAndMixTier._id);

  if (showPickAndMix) {
    const { _id: id, name, cover, slug } = firstPickAndMixTier;

    bundles.push({
      _id: id,
      name,
      cover,
      slug,
      pickAndMixQuantity,
      pickAndMixPrice,
      pickAndMixPercent,
      percentageBased: firstPickAndMixTier.percent > 0,
      type: 'pick-and-mix',
    });
  }

  /* eslint-disable no-param-reassign */
  bundles.forEach((bundle) => {
    // convert prices to hitcard format
    bundle.priceFixed = mapValues(bundle.currentPrice || bundle.price,
      price => price / 100);
    bundle.fullPriceFixed = mapValues(bundle.fullPrice,
      fullPrice => fullPrice / 100);

    if (bundle.current_discount && bundle.current_discount.percent) {
      bundle.discount_percent = bundle.current_discount.percent * 100;
    }

    if (bundle.pickAndMixPrice) {
      bundle.pickAndMixPrice = mapValues(firstPickAndMixTier.price,
        price => price / 100);
    }

    bundle.tiered = bundle.isTiered;
  });

  let lowestPriceBundle = bundles[0];

  bundles.forEach((bundle) => {
    if (bundle.current_discount && bundle.current_discount.percent) {
      if (lowestPriceBundle.type === 'bundle' && bundle.currentPrice[currencyCode] < lowestPriceBundle.currentPrice[currencyCode]) {
        lowestPriceBundle = bundle;
      }
      if (lowestPriceBundle.type === 'pick-and-mix' && bundle.currentPrice[currencyCode] < lowestPriceBundle.pickAndMixPrice[currencyCode]) {
        lowestPriceBundle = bundle;
      }
    }

    if (bundle.pickAndMixPrice) {
      if (lowestPriceBundle.type === 'bundle' && bundle.pickAndMixPrice[currencyCode] < lowestPriceBundle.currentPrice[currencyCode]) {
        lowestPriceBundle = bundle;
      }
      if (lowestPriceBundle.type === 'pick-and-mix' && bundle.pickAndMixPrice[currencyCode] < lowestPriceBundle.pickAndMixPrice[currencyCode]) {
        lowestPriceBundle = bundle;
      }
    }
  });

  return lowestPriceBundle || {};
};

export default FormatPartOfBundle;
